import { useState } from 'react';
import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import FiltersSection from '../components/FiltersSection';
import {
  DailyDowngradeSubscriptionChart,
  DailyUpgradeSubscriptionChart,
  DailyFirstTimeSubscriptionChart,
  // DailyRefundsChart,
  DailyChurnedPremiumUsersChart,
  DailyReactivedPremiumUsersChart,
  // DailyPromoCodeAliasChart,
  DailyFaildToRenewPremiumUsersChart,
} from '../components/PaymentCharts';
export interface ChartsProps {
  dates: Date[];
}

const GeneralAnalysisPage = () => {
  const [dates, setDates] = useState<Date[]>([
    new Date(Date.now() - 30 * 24 * 3600 * 1000),
    new Date(),
  ]);

  return (
    <PageLayoutsContainer
      title={`General Analysis`}
      withoutRightPadding={false}
    >
      <div className="space-y-6 ">
        <FiltersSection
          dates={dates}
          setDates={(dates) => {
            setDates(dates);
          }}
          autoSelectDatesDirection="horizontal"
        />

        <div className="grid grid-cols-2  gap-4">
          <DailyFirstTimeSubscriptionChart dates={dates} />
          <DailyDowngradeSubscriptionChart dates={dates} />

          <DailyUpgradeSubscriptionChart dates={dates} />
          {/* <DailyRefundsChart dates={dates} /> */}
          <DailyChurnedPremiumUsersChart dates={dates} />
          <DailyReactivedPremiumUsersChart dates={dates} />
          {/* <DailyPromoCodeAliasChart dates={dates} /> */}
          <DailyFaildToRenewPremiumUsersChart dates={dates} />
        </div>
      </div>
    </PageLayoutsContainer>
  );
};

export default GeneralAnalysisPage;
